import React from 'react'
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Text from '../../form/form-text'
import Select from '../../form/form-text'
import Upload from '../../form/upload/file'
import Image from '../../image-panel/imagePanel'

class ModuleContentSlideshow extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            data: this.props,
            disabled: this.props.disabled
        }
        this.i18n = 'app.modules.components'
        this.types = ["Carousel", "Mosaique"].map( t => ({id: t, value: t}) );
        this.sorters = ["Date de publication", "Popularité"].map( t => ({id: t, value: t}) );
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({disabled: nextProps.disabled})
    }

    render() {
        let { description, dash, hls, progressive, poster, title } = this.state.data;
        let { disabled } = this.state;

        return <div className="module-contentSlideshow">
            <Text disabled={disabled} label={'app.title'} value={title} />
            <Select disabled={disabled} value={type} options={this.types} />


            <Select disabled={disabled} value={sorter} options={this.sorters} />

            <Select disabled={disabled} label={'app.description'} value={description} />
            <Text disabled={disabled} label={this.i18n + 'dash'} value={dash} />
            <Text disabled={disabled} label={this.i18n + 'hls'} value={hls} />
            <Text disabled={disabled} label={this.i18n + 'progressive'} value={progressive} />

            {!disabled && <Upload  label={this.i18n + 'poster'} value={poster} />}
            {disabled && <Image value={data.imageFB} id={i18n + 'imageFB'} />}
        </div>;
    }
}

ModuleContentSlideshow.propTypes = {
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool, // souhld be .isRequired,
    isCustom: PropTypes.bool, // souhld be .isRequired,,
    title: PropTypes.string,
    description: PropTypes.string,
    dash: PropTypes.string,
    hls: PropTypes.string,
    progressive: PropTypes.string,
    poster: PropTypes.string
}

export default ModuleContentSlideshow;

